import {
  useHasAllPermissions,
  useHasAnyPermission,
  useHasPermission,
} from "@src/modules/member/hooks/use-permissions";
import { ReactNode } from "react";

interface RequirePermissionProps {
  permission?: string;
  any?: string[];
  all?: string[];
  fallback?: ReactNode;
  children: ReactNode;
}

export default function RequirePermission({
  permission,
  any: anyPermissions,
  all: allPermissions,
  fallback = null,
  children,
}: RequirePermissionProps) {
  const hasSingle = useHasPermission(permission ?? "");
  const hasAny = useHasAnyPermission(anyPermissions ?? []);
  const hasAll = useHasAllPermissions(allPermissions ?? []);

  const isAllowed = permission
    ? hasSingle
    : anyPermissions
      ? hasAny
      : allPermissions
        ? hasAll
        : false;

  if (!isAllowed) {
    return <>{fallback}</>;
  }

  return <>{children}</>;
}
